import React, { useState } from "react";
import { Box, Button } from "@mui/material";
import FilterAccordion from "./FilterAccordion";
import DatetimeRangePicker from "react-bootstrap-daterangepicker";
import _ from "lodash";
import moment from "moment";
import "bootstrap-daterangepicker/daterangepicker.css";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { describeRange } from "../Inbox/Utilities/inboxUtils";


export default function DateRangeFilter({
  startDate,
  endDate,
  handleChange,
}) {
  const [defaultStartDate, setDefaultStartDate] = useState(
    !_.isEmpty(startDate) ? moment(startDate) : moment().subtract(6, "days"),
  );
  const [defaultEndDate, setDefaultEndDate] = useState(
    !_.isEmpty(endDate) ? moment(endDate) : moment().subtract(),
  );
  const placeholder = `${defaultStartDate.format("MM/DD/YYYY")} - ${defaultEndDate.format("MM/DD/YYYY")}`;

  const ranges = [
    {
      label: "Last 24 hours",
      range: [moment().subtract(24, "hours"), moment()],
    },
    {
      label: "Past 7 days",
      range: [moment().subtract(6, "days"), moment()],
    },
    {
      label: "Past 30 days",
      range: [moment().subtract(29, "days"), moment()],
    },
    {
      label: "Last month",
      range: [
        moment().subtract(1, "month").startOf("month"),
        moment().subtract(1, "month").endOf("month"),
      ],
    },
    {
      label: "Last quarter",
      range: [
        moment().subtract(1, "quarter").startOf("quarter"),
        moment().subtract(1, "quarter").endOf("quarter"),
      ],
    },
    {
      label: "Year to date",
      range: [moment().startOf("year"), moment()],
    },
  ];
  const helperText = describeRange(defaultStartDate, defaultEndDate, ranges);

  function applyRange(start, end) {
    setDefaultStartDate(start);
    setDefaultEndDate(end);
    handleChange?.(start, end);
  }

  function handleEvent(event, picker) {
    if (_.get(event, "handleObj.type") === "apply") {
      applyRange(picker.startDate, picker.endDate);
    }
  }

  return (
    <FilterAccordion label="Date range" helperText={helperText}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: "6px" }}>
        {ranges.map((item, index) => {
          const isActive = helperText === item.label;
          return (
            <Button
              key={index}
              sx={{
                ...styles.rangesBtn,
                ...(isActive && styles.rangesBtnActive),
              }}
              onClick={() => applyRange(item.range[0], item.range[1])}
            >
              {item.label}
            </Button>
          );
        })}

        <Box sx={styles.input}>
          <CalendarMonthIcon sx={styles.inputIcon} />
          <DatetimeRangePicker
            startDate={defaultStartDate}
            endDate={defaultEndDate}
            onEvent={handleEvent}
            drops="up"
          >
            <input
              className="input-popup color-grey-dark font-14 tms-ellipsis"
              type="text"
              placeholder={placeholder}
              tabIndex="-1"
            />
          </DatetimeRangePicker>
        </Box>
      </Box>
    </FilterAccordion>
  );
}


const styles = {
  rangesBtn: {
    fontFamily: "FustatSemiBold",
    color: "#33413a",
    fontSize: "14px",
    width: "100%",
    borderRadius: "10px",
    textTransform: "none",
    height: "40px",
    textAlign: "left",
    border: "1px solid #e3ddd3",
    display: "block",
  },
  rangesBtnActive: {
    border: "1px solid #12321f",
    backgroundColor: "#eef2ef",
    "&:hover": {
      backgroundColor: "#eef2ef",
    },
  },
  input: {
    height: "40px",
    borderRadius: "8px",
    overflow: "hidden",
    width: { xs: "100%", sm: "auto" },
    position: "relative",
    backgroundColor: "#fff",
    display: "flex",
    alignItems: "center",
    border: "1.5px solid #e3ddd3",
    "*": {
      fontFamily: "FustatSemiBold",
      fontSize: "14px",
      backgroundColor: "transparent",
      border: "none!important",
      outline: "none!important",
      cursor: "pointer",
      "::placeholder": {
        color: "#003300",
      },
    },
    ".react-bootstrap-daterangepicker-container": {
      width: "100%",

      input: {
        color: "#33413a",
        paddingLeft: "16px",
        marginRight: "-68px",
        width: "280px",
      },
    },
  },
  inputIcon: {
    fontSize: "20px!important",
    flexShrink: 0,
    color: "#33413a",
    mr: "-5px",
    ml: "10px",
    pointerEvents: "none",
  },
};
